module.exports = "/images/vendor/flag-icon-css/flags/4x3/gq.svg?30ed019c10e7044f26649ac9e9a84c8a";